module.exports = __webpack_public_path__ + "img/cliu3.24be6399.png";